import React, { createContext, useContext, useState, useEffect } from 'react';
import { httpRequest, httpRequestUtil } from '../api/helper';
import { AuthContext } from '../context/AuthContext';
import { useNotification } from './NotificationContext';
import { DEFAULT_ERROR_MESSAGE, API_ERROR_MESSAGE } from '../common/AppConstants';

const USER_API_URL = 'user/profile/';

// Create the Account Context
const AccountContext = createContext();

// Custom hook for easy access
export const useAccount = () => useContext(AccountContext);

// AccountProvider Component
export const AccountProvider = ({ children }) => {
  const { addNotification } = useNotification();
  const { loggedIn, authLoading } = React.useContext(AuthContext);
  const [account, setAccount] = useState({ user: {}, organization: {} });

  const fetchAccountData = async () => {
    if (!loggedIn || authLoading) {
      return; // Skip fetching if user is not logged in
    }

    // Fetch user profile details
    await httpRequest({
      method: 'GET',
      url: USER_API_URL,
      onSuccess: (data) => {
        const orgList = data.user?.org_and_role_list || [];
        const orgInfo = orgList.find(
          (org) => org.id === data.user?.current_org
        );
        setAccount({
          user: data.user,
          organization: orgInfo,
        });
      },
      addNotification,
    });
  };

  useEffect(() => {
    fetchAccountData();
  }, [loggedIn, authLoading]);

  const updateUser = async (payload) => {
    // Update details
    const response = await httpRequest({
      method: 'PUT',
      url: USER_API_URL,
      data: payload,
      onSuccess: (data) => {
        const orgList = data?.org_and_role_list || [];
        const orgInfo = orgList.find(
          (org) => org.id === data?.current_org
        );
        setAccount({
          user: data,
          organization: orgInfo,
        });
      },
      addNotification,
    });

    return response;
  };

  return (
    <AccountContext.Provider
      value={{
        account,
        updateUser,
        fetchAccountData,
      }}>
      {children}
    </AccountContext.Provider>
  );
};
